module.exports = __webpack_public_path__ + "static/media/gl.ba08dffb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/gl.svg
// module id = 129
// module chunks = 0